import GuiCmsSrv from "@/services/GuiCmsSrv";
import Api from "@/services/Api";
import DStd from "@/DStd.js";

import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

// import GuestTalkStore from "@/modules/GuestTalkStore";

const GuiCmsStore = {
  namespaced: true,
  state: {
    list: [],
    tree: [],
    appCfg: null,
    siteCfg: null,
    chpl: null,
    customevts: null,
    guiMediaPlaylists: null,
    cwatch: null,
    weatherloc: [],
    surveylst: [],
    folios: null,
    user: null,
    hskpStatItms: [],
    hskpMbarItms: [],
    customplayers: [],
    customplayergroups: [],
    tccLst: null,
    netmon: { devs: [], light: [] },
    langid: 1,
    gtalk: {
      sessions: [],
      connected: false,
      msgs: [],
      lastMsgTm: null,
      hasNewMsg: false,
      notifs: {
        lst: []
      }
    },
    cw: {
      connStat: false,
      // lst: [],
      regEvs: []
    },
    sig: {
      plrs: [],
      places: [],
      tm1: null
    }
  },
  getters: {
    SIGN_PLACES: state => {
      return state.sig.places;
    },
    SIGN_PLRS: state => {
      return state.sig.plrs;
    },
    CW_CONN_STAT: state => {
      return state.cw.connStat;
    },
    LANGID: state => {
      return state.langid;
    },
    LANG: state => id => {
      if (state.siteCfg == null) return null;
      let l = state.siteCfg.langCfg.list;
      return l.find(c => c.id == id);
      // let a = l.findIndex(c => c.id == id);
      // return a != null ? l[a] : null;
    },
    LANGBYISO: state => isoCode => {
      if (state.siteCfg == null) return null;
      let l = state.siteCfg.langCfg.list;
      return l.find(c => c.isoLangs.trim().indexOf(isoCode) == 0);
      // let a = l.findIndex(c => c.id == id);
      // return a != null ? l[a] : null;
    },
    CURLANG: state => {
      let id = state.langid;
      if (state.siteCfg == null) return null;
      let l = state.siteCfg.langCfg.list;
      let a = l.findIndex(c => c.id == id);
      return a != null ? l[a] : null;
    },
    LIST: state => {
      return state.list;
    },
    TREE: state => {
      return state.tree;
    },
    APPCFG: state => {
      return state.appCfg;
    },
    SITECFG: state => {
      return state.siteCfg;
    },
    STDTVPROFILE: state => {
      if (state.siteCfg == null) return null;
      let l1 = state.siteCfg.tvCfgs;
      if (l1.length < 1) return null;
      let stdTvCtg = state.siteCfg.stdTvCtg;
      let r1 = l1.find(a => a.id == stdTvCtg);
      return r1 == null ? l1[0] : r1;
    },
    CHPL: state => {
      return state.chpl;
    },
    CUSTOMEVTLIST: state => {
      return state.customevts;
    },
    GUIMEDIAPLAYLISTS: state => {
      return state.guiMediaPlaylists;
    },
    WEATHERLOC: state => {
      return state.weatherloc;
    },
    SURVEYLST: state => {
      return state.surveylst;
    },
    FOLIOS: state => {
      return state.folios;
    },
    USER: state => {
      return state.user;
    },
    HASROLE: state => n => {
      let u = state.user;
      if (u == null || !Array.isArray(u.roles)) return false;
      let rs = Array.isArray(n) ? n : new Array(n);
      for (let i = 0; i < rs.length; i++) {
        let rn = rs[i];
        if (u.roles.findIndex(r => r.name == "ROLE_" + rn) >= 0) return true;
      }
      return false;
    },
    HSKPSTAT_LST: state => {
      return state.hskpStatItms;
    },
    // CUSTOMPLAYER_LST: state => {
    //   return state.customplayers;
    // },
    CUSTOMPLAYERGROUP_LST: state => {
      return state.customplayergroups;
    },
    TCCLST: state => {
      return state.tccLst;
    },
    GTALK_MSGSUNREAD_FN: state => n => {
      let a = state.gtalk.msgs.find(s1 => s1.folioNum == n);
      if (a && a.hasUnread) return true;
      return false;
    },
    GTALK_MSGS_FN: state => n => {
      return state.gtalk.msgs.find(s1 => s1.folioNum == n);
    },
    GTALK_NOTIFS: state => {
      return state.gtalk.notifs;
    },
    GTALK_CONN: state => {
      return state.gtalk.connected;
    },
    GTALK_SLST: state => {
      return state.gtalk.sessions;
    }
  },
  mutations: {
    SIGN_SETCHK: async (state, pld) => {
      state.sig.chkTm = pld;
    },
    SIGN_SETPLRS: async (state, pld) => {
      state.sig.plrs = pld;
    },
    SIGN_SETPLACES: async (state, pld) => {
      state.sig.places = pld;
    },
    CW_CONN_STAT: async (state, pld) => {
      state.cw.connStat = pld || pld >= 1 ? true : false;
    },
    CW_EVT_ON: async (state, pld) => {
      let l = state.cw.regEvs;
      let a = l.findIndex(o => o.uid == pld.uid);
      if (a >= 0) l.splice(a, 1, pld);
      else l.push(pld);
      state.cw.regEvs = l;
    },
    CW_EVT_OFF: async (state, pld) => {
      let l = state.cw.regEvs;
      let a = l.findIndex(o => o.uid == pld.uid);
      if (a >= 0) l.splice(a, 1);
      state.cw.regEvs = l;
    },
    SET_LANGID: (state, pld) => {
      state.langid = pld;
    },
    SET_SITECFG: (state, pld) => {
      state.siteCfg = pld;
    },
    SET_APPCFG: (state, pld) => {
      state.appCfg = pld;
    },
    SET_CHPL: (state, pld) => {
      state.chpl = pld;
    },
    SET_LIST: (state, pld) => {
      state.list = pld;
    },
    SET_TREE: (state, pld) => {
      state.tree = pld;
    },
    ADD: (state, pld) => {
      state.list.push(pld);
    },
    UPD_PL_ITEMS: (state, pld) => {
      let fi2 = state.list.findIndex(x => x.id == pld.guiItmId);
      if (fi2 >= 0) state.list[fi2].plItems = pld;
    },
    UPD: (state, pld) => {
      let fi2 = state.list.findIndex(x => x.id == pld.id);
      if (fi2 >= 0) state.list[fi2] = pld;
    },
    DEL_ITEMS: (state, pld) => {
      state.list = state.list.filter(itm => pld.items.indexOf(itm.id) < 0);
    },
    DEL: (state, id) => {
      state.list = state.list.filter(itm => itm.id != id);
    },
    MOVE: (state, pld) => {
      let arr = state.list.slice();
      let a = state.list.findIndex(x => x.id == pld.src);
      let b = state.list.findIndex(x => x.id == pld.dst);
      if (a < 0 || b < 0) return;
      arr = DStd.array_move(arr, a, b);
      // arr = this.$dstd.array_move(arr, a, b);
      state.list = arr;
    },
    CUSTOMEVTLIST_SET: (state, pld) => {
      state.customevts = pld;
    },
    CUSTOMEVTLIST_ADD: (state, pld) => {
      state.customevts.push(pld);
    },
    CUSTOMEVTLIST_UPD: (state, pld) => {
      let i = state.customevts.findIndex(x => x.id == pld.id);
      if (i >= 0) state.customevts[i] = pld;
    },
    CUSTOMEVTLIST_DEL: (state, id) => {
      state.customevts = state.customevts.filter(itm => itm.id != id);
    },
    CUSTOMEVTLIST_UPD_PL_ITEMS: (state, pld) => {
      let fi2 = state.list.findIndex(x => x.id == pld.guiCustomEventId);
      if (fi2 >= 0) state.list[fi2].plItems = pld;
    },
    GUIMEDIAPLAYLIST_SET: (state, pld) => {
      state.guiMediaPlaylists = pld;
    },
    GUIMEDIAPLAYLIST_ADD: (state, pld) => {
      state.guiMediaPlaylists.push(pld);
    },
    GUIMEDIAPLAYLIST_UPD: (state, pld) => {
      let i = state.guiMediaPlaylists.findIndex(x => x.id == pld.id);
      if (i >= 0) state.guiMediaPlaylists.splice(i, 1, pld);
      // if (i >= 0) state.guiMediaPlaylists[i] = pld;
    },
    GUIMEDIAPLAYLIST_DEL: (state, id) => {
      state.guiMediaPlaylists = state.guiMediaPlaylists.filter(
        itm => itm.id != id
      );
    },
    GUIMEDIAPLAYLIST_UPD_PL_ITEMS: (state, pld) => {
      let fi2 = state.list.findIndex(x => x.id == pld.guiMediaPlaylistId);
      if (fi2 >= 0) state.list[fi2].plItems = pld;
    },
    WEATHERLOC_SET: (state, pld) => {
      state.weatherloc = pld;
    },
    WEATHERLOC_ADD: (state, pld) => {
      state.weatherloc.push(pld);
    },
    WEATHERLOC_UPD: (state, pld) => {
      let i = state.weatherloc.findIndex(x => x.id == pld.id);
      if (i >= 0) state.weatherloc.splice(i, 1, pld);
    },
    WEATHERLOC_DEL: (state, id) => {
      state.weatherloc = state.weatherloc.filter(itm => itm.id != id);
    },
    SURVEYLST_SET: (state, pld) => {
      state.surveylst = pld;
    },
    SURVEYLST_ADD: (state, pld) => {
      state.surveylst.push(pld);
    },
    SURVEYLST_UPD: (state, pld) => {
      let i = state.surveylst.findIndex(x => x.id == pld.id);
      if (i >= 0) state.surveylst.splice(i, 1, pld);
    },
    SURVEYLST_DEL: (state, id) => {
      state.surveylst = state.surveylst.filter(itm => itm.id != id);
    },
    FOLIOS_SET: (state, pld) => {
      state.folios = pld;
    },
    FOLIOS_ADD: (state, pld) => {
      state.folios.push(pld);
    },
    FOLIOS_UPD: (state, pld) => {
      let i = state.folios.findIndex(x => x.id == pld.id);
      if (i >= 0) state.folios.splice(i, 1, pld);
    },
    FOLIOS_DEL: (state, pld) => {
      state.folios = state.folios.filter(itm => itm.id != pld.id);
    },
    USER_SET: (state, pld) => {
      if (pld == null || pld == "") state.user = null;
      else state.user = pld;
    },
    HSKPSTAT_SET: (state, pld) => {
      state.hskpStatItms = pld;
    },
    HSKPSTAT_ADD: (state, pld) => {
      state.hskpStatItms.push(pld);
    },
    HSKPSTAT_UPD: (state, pld) => {
      let i = state.hskpStatItms.findIndex(x => x.id == pld.id);
      if (i >= 0) state.hskpStatItms.splice(i, 1, pld);
    },
    HSKPSTAT_UPDLST: (state, pld) => {
      if (Array.isArray(pld)) {
        pld.forEach(it => {
          let i = state.hskpStatItms.findIndex(x => x.id == it.id);
          if (i >= 0) state.hskpStatItms.splice(i, 1, it);
        });
      }
    },
    HSKPSTAT_DEL: (state, id) => {
      state.hskpStatItms = state.hskpStatItms.filter(itm => itm.id != id);
    },
    // CUSTOMPLAYER_SET: (state, pld) => {
    //   state.customplayers = pld;
    // },
    CUSTOMPLAYERGROUP_SET: (state, pld) => {
      state.customplayergroups = pld;
    },
    TCCLST_SET: (state, pld) => {
      state.tccLst = pld;
    },
    GTALK_SETNOTIFS: (state, pld) => {
      state.gtalk.notifs.lst = pld;
    },
    GTALK_SETSLST: (state, pld) => {
      state.gtalk.sessions = pld;
    },
    GTALK_CON: (state, pld) => {
      state.gtalk.connected = pld;
    },
    GTALK_SETFOLMSGS: (state, pld) => {
      let nmsgs = {
        seId: null,
        folioNum: pld.folioNum,
        msgs: pld.dt,
        lastMsgTm: null,
        hasUnread: true
      };
      let i = state.gtalk.msgs.findIndex(x => x.folioNum == pld.folioNum);
      if (i >= 0) {
        state.gtalk.msgs.splice(i, 1, nmsgs);
      } else {
        state.gtalk.msgs.push(nmsgs);
      }
    },
    GTALK_MSGREAD: (state, fn) => {
      let i = state.gtalk.msgs.findIndex(x => x.folioNum == fn);
      if (i < 0) return;
      state.gtalk.msgs[i].hasUnread = false;
    },
    GTALK_MSGADD: (state, pld) => {
      let i = state.gtalk.msgs.findIndex(x => x.folioNum == pld.folioNum);
      if (i >= 0) {
        state.gtalk.msgs[i].msgs.push(pld);
        state.gtalk.msgs[i].lastMsgTm = new Date();
        state.gtalk.msgs[i].hasUnread = pld.origin == 0 ? false : true;
      } else {
        state.gtalk.msgs.push({
          seId: pld.seId,
          folioNum: pld.folioNum,
          msgs: [pld],
          lastMsgTm: new Date(),
          hasUnread: pld.origin == 0 ? false : true
        });
      }
    },
    GTALK_SEID_DEL: (state, seId) => {
      // let i = state.gtalk.msgs.findIndex(x => x.seId == seId);
      // if (i >= 0) state.gtalk.msgs.splice(i, 1);
      let i = state.gtalk.sessions.findIndex(x => x.seId == seId);
      if (i >= 0) state.gtalk.sessions.splice(i, 1);
    },
    GTALK_SEID_NEW: (state, pld) => {
      let i = state.gtalk.sessions.findIndex(x => x.seId == pld.seId);
      if (i >= 0) state.gtalk.sessions.splice(i, 1, pld);
      else state.gtalk.sessions.push(pld);
    }
  },
  actions: {
    SIGN_CHKUPD: async ({ commit }, pld) => {
      commit("SIGN_SETCHK", 0);
    },
    SIGN_CHKPLRS: async ({ commit, state, dispatch }, pld) => {
      if (state.sig.plrs.length < 1 || Date.now() - state.sig.chkTm > 60000)
        dispatch("SIGN_GETPLRS");
    },
    SIGN_GETPLRS: async ({ commit }) => {
      // let { data } = await Api().get("/tccSigPlrs");
      let { data } = await Api().get("/guicustomplayergroup/user-sigplrs");
      commit("SIGN_SETPLRS", data);
      commit("SIGN_SETCHK", Date.now());
    },
    SIGN_CHKPLACES: async ({ commit, state, dispatch }, pld) => {
      if (state.sig.places.length < 1 || Date.now() - state.sig.chkTm > 60000)
      dispatch("SIGN_GETPLACES");
    },
    SIGN_GETPLACES: async ({ commit }, pld) => {
      let { data } = await Api().get("/guicustomevt/places");
      commit("SIGN_SETPLACES", data);
      commit("SIGN_SETCHK", Date.now());
    },
    CW_CONNECT: async ({ commit, state, dispatch }, pld) => {
      let user = state.user;
      if (user == null) {
        console.log("cwt.connt.e: !user");
        return;
      }
      // console.log("cwt.conn..");
      state.cw.sock = new SockJS("/gtalk1");
      let stompCl = Stomp.over(state.cw.sock);
      stompCl.debug = () => {};
      stompCl.heartbeat.outgoing = 30000;
      stompCl.heartbeat.incoming = 30000;
      stompCl.onDisconnect = () => {
        // console.log("cwt.onDisconnect...");
        commit("CW_CONN_STAT", 0);
        setTimeout(() => {
          dispatch("CW_REQCONN");
        }, 5000);
      };
      stompCl.onWebSocketClose = () => {
        // console.log("cwt.wsClose");
        commit("CW_CONN_STAT", 0);
        setTimeout(() => {
          dispatch("CW_REQCONN");
        }, 5000);
      };
      stompCl.connect(
        user.username,
        "",
        frame => {
          // console.log("cwt.connected");
          commit("CW_CONN_STAT", 1);
          state.cw.stompCl.subscribe("/topic/cwevt", tick => {
            let aa = JSON.parse(tick.body);
            dispatch("CW_EVT", aa);
          });
        },
        error => {
          // console.log("cwt.stomp.ERR: " + error);
          commit("CW_CONN_STAT", 0);
        }
      );
      state.cw.stompCl = stompCl;
    },
    CW_DISCONNECT: async ({ commit, state }, pld) => {
      // console.log("cwt.diconnect.req");
      if (state.cw.stompCl) {
        // console.log("cwt.disconnecting..v2");
        state.cw.stompCl.disconnect();
      }
      commit("CW_CONN_STAT", 0);
    },
    CW_CHKCONN: async ({ commit, state, dispatch }, pld) => {
      let user = state.user;
      if (!user || state.cw.connStat) return;
      dispatch("CW_CONNECT");
    },
    CW_REQCONN: async ({ commit, state, dispatch }, pld) => {
      // console.log("cwt: reqConn");
      let user = state.user;
      if (user && !state.cw.connStat) {
        dispatch("CW_CONNECT");
      }
    },
    CW_REQDISCONN: async ({ commit, state, dispatch }, pld) => {
      if (!state.cw.connStat) return;
      // console.log("cwt: need2disconn");
      dispatch("CW_DISCONNECT");
    },
    CW_EVT: async (ctx, pld) => {
      // console.log(
      //   "CW_EVT(" +
      //     ctx.state.cw.regEvs.length +
      //     "): " +
      //     pld.type +
      //     "." +
      //     pld.prm1
      // );
      // console.log(
      //   "CW_EVT(" +
      //     ctx.state.cw.regEvs.length +
      //     "): " +
      //     JSON.stringify(pld)
      // );
      ctx.state.cw.regEvs.forEach(o => {
        if (o.hasOwnProperty("cwid") && o.cwid != null && pld.ci != null) {
          if (o.cwid != pld.ci) return;
        }
        if (
          pld.type != 4 &&
          (pld.type < 2 || pld.type > 6) &&
          o.hasOwnProperty("sn") &&
          pld.prm1
        ) {
          if (o.sn != pld.prm1) return;
        }
        if (typeof o.f === "function") o.f(pld);
      });
    },
    GET_APPCFG: async (ctx, pld) => {
      Api()
        .get("/appCfg")
        .then(dt => {
          ctx.commit("SET_APPCFG", dt.data);
        })
        .catch(e => {
          console.log("GET_APPCFG.e: " + e);
        });
    },
    GET_SITECFG: async (ctx, pld) => {
      let { data } = await Api().get("/siteCfg");
      ctx.commit("SET_SITECFG", data);
      return data;
    },
    GET_CHPL: async (ctx, pld) => {
      let { data } = await Api().get("/chpl");
      ctx.commit("SET_CHPL", data);
      return data;
    },
    SAVE_CHPL: async (ctx, pld) => {
      let { data } = await Api().post("/chpl", pld);
      if (data && data.hasOwnProperty("tvc")) ctx.commit("SET_CHPL", data);
      return data;
    },
    SAVE_SITECFG: async (ctx, pld) => {
      let { data } = await Api().post("/siteCfg", pld);
      ctx.commit("SET_SITECFG", data);
      return data;
    },
    GET_LIST: async (ctx, pld) => {
      GuiCmsSrv.getList(pld)
        .then(dt => {
          ctx.commit("SET_LIST", dt.data);
        })
        .catch(e => {
          console.log("GET_LIST.e: " + e);
        });
    },
    GET_TREE: async (ctx, pld) => {
      GuiCmsSrv.getTree(pld)
        .then(dt => {
          ctx.commit("SET_TREE", dt.data);
        })
        .catch(e => {
          console.log("GET_TREE.e: " + e);
        });
    },
    ADD: async (ctx, pld) => {
      let { data } = await GuiCmsSrv.newItm(pld);
      if (data && data.hasOwnProperty("name") && data.name == pld.name) {
        ctx.commit("ADD", data);
      } else {
        ctx.commit("ADD", pld);
      }
      return data;
    },
    UPD: async (ctx, pld) => {
      let { data } = await GuiCmsSrv.updItm(pld);
      ctx.commit("UPD", data);
      return data;
    },
    ADD_PL_ITEMS: async (ctx, pld) => {
      let { data } = await GuiCmsSrv.addPlItems(pld);
      if (data && data.hasOwnProperty("id")) ctx.commit("UPD_PL_ITEMS", data);
      return data;
    },
    UPD_PL_ITEMS: async (ctx, pld) => {
      let { data } = await GuiCmsSrv.updPlItems(pld);
      if (data && data.hasOwnProperty("id")) ctx.commit("UPD_PL_ITEMS", data);
      return data;
    },
    DEL_ITEMS: async (ctx, pld) => {
      let { data } = await GuiCmsSrv.delItms(pld.items);
      ctx.commit("DEL_ITEMS", pld);
      return data;
    },
    DEL: async (ctx, pld) => {
      let { data } = await GuiCmsSrv.delItm(pld.id);
      ctx.commit("DEL", pld.id);
      return data;
    },
    MOVE_BACK: async ({ commit, state }, pld) => {
      let a1 = state.list.filter(el => el.parentId === pld.parentId);
      let c1 = a1.findIndex(el => el.id === pld.id);
      if (c1 < 1) return; //cannot move back
      let c2 = c1 - 1;
      GuiCmsSrv.moveToLeftOf({ src: a1[c1].id, dst: a1[c2].id }).then(dt => {
        commit("MOVE", { src: a1[c1].id, dst: a1[c2].id });
      });
    },
    MOVE_FWD: async ({ commit, state }, pld) => {
      let a1 = state.list.filter(el => el.parentId === pld.parentId);
      let c1 = a1.findIndex(el => el.id === pld.id);
      if (c1 < 0 || c1 + 1 >= a1.length) return; //cannot move fwd
      let c2 = c1 + 1;
      GuiCmsSrv.moveToRightOf({ src: a1[c1].id, dst: a1[c2].id }).then(dt => {
        commit("MOVE", { src: a1[c1].id, dst: a1[c2].id });
      });
    },
    CUSTOMEVTLIST_GETLIST: async (ctx, pld) => {
      let { data } = await Api().get("/guicustomevt");
      ctx.commit("CUSTOMEVTLIST_SET", data);
      return data;
    },
    CUSTOMEVTLIST_ADD: async (ctx, pld) => {
      let { data } = await Api().post("/guicustomevt", pld);
      ctx.commit("CUSTOMEVTLIST_ADD", data);
      return data;
    },
    CUSTOMEVTLIST_UPD: async (ctx, pld) => {
      let { data } = await Api().put("/guicustomevt/" + pld.id, pld);
      ctx.commit("CUSTOMEVTLIST_UPD", data);
      return data;
    },
    CUSTOMEVTLIST_DEL: async (ctx, pld) => {
      let { data } = await Api().delete("/guicustomevt/" + pld.id);
      ctx.commit("CUSTOMEVTLIST_DEL", pld.id);
      return data;
    },
    CUSTOMEVTLIST_ADD_PL_ITEMS: async (ctx, pld) => {
      let { data } = await Api().post(
        "/guicustomevt/" + pld.id + "/addPlItems",
        pld.plItems
      );
      if (data && data.hasOwnProperty("id"))
        ctx.commit("CUSTOMEVTLIST_UPD_PL_ITEMS", data);
      return data;
    },
    CUSTOMEVTLIST_UPD_PL_ITEMS: async (ctx, pld) => {
      let { data } = await Api().post(
        "/guicustomevt/" + pld.id + "/updPlItems",
        pld.plItems
      );
      if (data && data.hasOwnProperty("id"))
        ctx.commit("CUSTOMEVTLIST_UPD_PL_ITEMS", data);
      return data;
    },
    GUIMEDIAPLAYLIST_GETLIST: async (ctx, pld) => {
      let { data } = await Api().get("/guimediaplaylist");
      ctx.commit("GUIMEDIAPLAYLIST_SET", data);
      return data;
    },
    GUIMEDIAPLAYLIST_ADD: async (ctx, pld) => {
      let { data } = await Api().post("/guimediaplaylist", pld);
      ctx.commit("GUIMEDIAPLAYLIST_ADD", data);
      return data;
    },
    GUIMEDIAPLAYLIST_UPD: async (ctx, pld) => {
      let { data } = await Api().put("/guimediaplaylist/" + pld.id, pld);
      ctx.commit("GUIMEDIAPLAYLIST_UPD", data);
      return data;
    },
    GUIMEDIAPLAYLIST_DEL: async (ctx, pld) => {
      let { data } = await Api().delete("/guimediaplaylist/" + pld.id);
      ctx.commit("GUIMEDIAPLAYLIST_DEL", pld.id);
      return data;
    },
    GUIMEDIAPLAYLIST_ADD_PL_ITEMS: async (ctx, pld) => {
      let { data } = await GuiCmsSrv.addGuiMediaPlaylistItems(pld);
      if (data && data.hasOwnProperty("id"))
        ctx.commit("GUIMEDIAPLAYLIST_UPD_PL_ITEMS", data);
      return data;
    },
    GUIMEDIAPLAYLIST_UPD_PL_ITEMS: async (ctx, pld) => {
      let { data } = await GuiCmsSrv.updGuiMediaPlaylistItems(pld);
      if (data && data.hasOwnProperty("id"))
        ctx.commit("GUIMEDIAPLAYLIST_UPD_PL_ITEMS", data);
      return data;
    },
    WEATHERLOC_GETLST: async (ctx, pld) => {
      let { data } = await Api().get("/weather/location");
      ctx.commit("WEATHERLOC_SET", data);
      return data;
    },
    WEATHERLOC_ADD: async (ctx, pld) => {
      let { data } = await Api().post("/weather/location", pld);
      ctx.commit("WEATHERLOC_ADD", data);
      return data;
    },
    WEATHERLOC_UPD: async (ctx, pld) => {
      let { data } = await Api().put("/weather/location/" + pld.id, pld);
      ctx.commit("WEATHERLOC_UPD", data);
      return data;
    },
    WEATHERLOC_DEL: async (ctx, pld) => {
      let { data } = await Api().delete("/weather/location/" + pld);
      ctx.commit("WEATHERLOC_DEL", pld);
      return data;
    },
    SURVEYLST_GETLST: async (ctx, pld) => {
      let { data } = await Api().get("/survey");
      ctx.commit("SURVEYLST_SET", data);
      return data;
    },
    SURVEYLST_ADD: async (ctx, pld) => {
      let { data } = await Api().post("/survey", pld);
      ctx.commit("SURVEYLST_ADD", data);
      return data;
    },
    SURVEYLST_UPD: async (ctx, pld) => {
      let { data } = await Api().put("/survey/" + pld.id, pld);
      ctx.commit("SURVEYLST_UPD", data);
      return data;
    },
    SURVEYLST_DEL: async (ctx, pld) => {
      let { data } = await Api().delete("/survey" + pld);
      ctx.commit("SURVEYLST_DEL", pld);
      return data;
    },
    FOLIOS_SET: async (ctx, pld) => {
      ctx.commit("FOLIOS_SET", pld);
      return pld;
    },
    FOLIOS_GETLST: async (ctx, pld) => {
      let filt = "";
      if (typeof pld === "object" && pld != null && pld.hasOwnProperty("bld")) {
        filt = "?bld=" + pld.bld;
      }
      let { data } = await Api().get("/folio" + filt);
      ctx.commit("FOLIOS_SET", data);
      return data;
    },
    FOLIOS_ADD: async (ctx, pld) => {
      let { data } = await Api().post("/folio/mkfolio", pld);
      ctx.commit("FOLIOS_ADD", data);
      return data;
    },
    FOLIOS_UPD: async (ctx, pld) => {
      let { data } = await Api().put("/folio/id/" + pld.id, pld);
      ctx.commit("FOLIOS_UPD", data);
      return data;
    },
    FOLIOS_DEL: async (ctx, pld) => {
      let { data } = await Api().delete("/folio/id/" + pld.id);
      ctx.commit("FOLIOS_DEL", pld);
      return data;
    },
    USER_GET: async (ctx, pld) => {
      Api()
        .get("/user")
        .then(dt => {
          ctx.commit("USER_SET", dt.data);
        })
        .catch(e => {
          console.log("getUser.e: " + e);
          ctx.commit("USER_SET", null);
        });
    },
    HSKPSTAT_GETLST: async (ctx, pld) => {
      let { data } = await Api().get("/hskp/hskpStat");
      ctx.commit("HSKPSTAT_SET", data);
      return data;
    },
    HSKPSTAT_ADD: async (ctx, pld) => {
      let { data } = await Api().post("/hskp/hskpStat", pld);
      ctx.commit("HSKPSTAT_ADD", data);
      return data;
    },
    HSKPSTAT_UPD: async (ctx, pld) => {
      let { data } = await Api().put("/hskp/hskpStat/" + pld.id, pld);
      ctx.commit("HSKPSTAT_UPD", data);
      return data;
    },
    HSKPSTAT_UPDLST: async (ctx, pld) => {
      let { data } = await Api().put("/hskp/hskpStatLst", pld);
      ctx.commit("HSKPSTAT_UPDLST", data);
      return data;
    },
    HSKPSTAT_DEL: async (ctx, id) => {
      let { data } = await Api().delete("/hskp/hskpStat/" + id);
      ctx.commit("HSKPSTAT_DEL", id);
      return data;
    },
    // CUSTOMPLAYER_GETLST: async (ctx, pld) => {
    //   let { data } = await Api().get("/guicustomplayer");
    //   ctx.commit("CUSTOMPLAYER_SET", data);
    //   return data;
    // },
    CUSTOMPLAYERGROUP_GETLST: async (ctx, pld) => {
      let { data } = await Api().get("/guicustomplayergroup");
      ctx.commit("CUSTOMPLAYERGROUP_SET", data);
      return data;
    },
    TCCLST_GET: async (ctx, pld) => {
      let { data } = await Api().get("/tvClientCfg");
      ctx.commit("TCCLST_SET", data);
      return data;
    },
    GTALK_GETFOLMSGS: async (ctx, folioNum) => {
      let { data } = await Api().get("/gtalk1/msglst/" + folioNum);
      ctx.commit("GTALK_SETFOLMSGS", { folioNum: folioNum, dt: data });
      return data;
    },
    GTALK_GETSLST: async (ctx, id) => {
      let { data } = await Api().get("/gtalk1/lst");
      ctx.commit("GTALK_SETSLST", data);
      return data;
    },
    GTALK_PROCNOTIF: ({ commit, state }, ntf) => {
      console.log("procNotif...");
      let sInd = -1;
      let ntfs = state.gtalk.notifs.lst;
      if (ntfs.length >= 150) {
        ntfs.splice(0, 80);
      }
      ntfs.push(ntf);
      commit("GTALK_SETNOTIFS", ntfs);
      switch (ntf.notifType) {
        case 1: //msgFromGuest
        case 2: //msgForGuest
          let msg = ntf;
          msg.createdAt = ntf.notifTime;
          msg.id = ntf.pldId1;
          msg.origin = ntf.notifType == 1 ? 1 : 0;
          commit("GTALK_MSGADD", msg);
          break;
        case 6: //guestSubscribe
          commit("GTALK_SEID_NEW", {
            id: ntf.seId,
            room: ntf.room,
            folioNum: ntf.folioNum,
            createdAt: ntf.notifTime,
            connected: true,
            lastMsg: null
          });
          break;
        case 3: //guestDisconnect
          commit("GTALK_SEID_DEL", ntf.seId);
          break;
      }
    }
  }
};

export default GuiCmsStore;
